import type { ComponentConfig } from '@puckeditor/core'
import ColorField from './ColorField'
import PaddingField, { type PaddingValue, paddingToStyle } from './PaddingField'

export interface DividerProps {
    color: string
    thickness: number
    style: 'solid' | 'dashed' | 'dotted'
    padding: PaddingValue
}

export const DividerBlock: ComponentConfig<DividerProps> = {
    label: 'Divider',
    defaultProps: {
        color: '#E5E7EB',
        thickness: 1,
        style: 'solid',
        padding: { top: 16, right: 0, bottom: 16, left: 0 },
    },
    fields: {
        color: {
            type: 'custom',
            render: ({ value, onChange }) => <ColorField label="Color" value={value} onChange={onChange} />,
        },
        thickness: { type: 'number', label: 'Thickness', min: 1, max: 10 },
        style: {
            type: 'radio',
            label: 'Line Style',
            options: [
                { label: 'Solid', value: 'solid' },
                { label: 'Dashed', value: 'dashed' },
                { label: 'Dotted', value: 'dotted' },
            ],
        },
        padding: {
            type: 'custom',
            render: ({ value, onChange }) => <PaddingField value={value} onChange={onChange} />,
        },
    },
    render: ({ color, thickness, style, padding }) => (
        <div style={{ padding: paddingToStyle(padding) }}>
            <hr style={{
                border: 'none',
                borderTop: `${thickness}px ${style} ${color}`,
                margin: 0,
            }} />
        </div>
    ),
}
